module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-medium-webfont.2bf252d6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-medium-webfont.woff
// module id = 377
// module chunks = 3